/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import FaqList from '../../../shared/Faq/components/FaqList.js';
import ContactUs from '../../../shared/ContactUs/components/ContactUs.js';
import './styles/styles.css';
import { FormattedHTMLMessage } from 'react-intl';

const Help = ({i18n}) => {
  return (
    <div data-id="Help">
      <div className="help-banner">
      </div>
      <div className="help-box">
        <div className="help-box-warp">
          <h1 className="help-title" data-key="title">{i18n.title}</h1>
          <p className="font-body1 help-tip1" data-key="helpTip1">{i18n.helpTip1}</p>
          <p className="font-body1 help-tip2" data-key="helpTip2"><FormattedHTMLMessage id="helpTip2" defaultMessage={i18n.helpTip2} /></p>

          <h2 className="help-sub-title" data-key="guideTitle">{i18n.guideTitle}</h2>
          <FaqList groups={i18n.groups} />
          <div className="contact-layer">
            <h2 className="help-sub-title" data-key="contactUs">{i18n.contactUs}</h2>
            <ContactUs i18n={i18n} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;


// WEBPACK FOOTER //
// ./src/views/Help/components/Help.js